import RestClient, { RestError } from './RestClient';
export { RestError };

export default {
  _rest: new RestClient('/api/'),
  LOG: 'debug/log',
  GAMES: 'games',
  MOVES_OF: g => `games/${g}/moves`,
  VARIATIONS_OF: (g, i) => `games/${g}/moves/${i}/variations`,
  ESTIMATES: 'ai/estimates',

  async getList(r, params) {
    return await this._rest.get_ex(`${r}/`, { params });
  },

  async get(r, id) {
    return await this._rest.get(`${r}/${id}`)
  },

  async post(r, obj) {
    return await this._rest.post(r, obj);
  },

  // Calls the API and returns the reply's data; errors are thrown as RestError (code in .msg).
  async call(method, url, body) {
    const r = await this._rest.call(method, url, body);
    return r.data;
  },

  async log(msg) {
    return await this.post(this.LOG, { log: msg });
  }
}
